export var HtmlNode;
(function (HtmlNode) {
    HtmlNode["Block"] = "html_block";
    HtmlNode["Inline"] = "html_inline";
})(HtmlNode || (HtmlNode = {}));
export var HtmlAttr;
(function (HtmlAttr) {
    HtmlAttr["Content"] = "html-content";
})(HtmlAttr || (HtmlAttr = {}));
